import { MessageDescriptor } from 'react-intl';
import * as yup from 'yup';
import { getRfidCardOwner } from '../api/userApi';
import { removeLeadingZeros } from '../components/UserRfidModalNew/helpers';
import messages from './messages';

export enum FormFieldNames {
  CardType = 'cardType',
  DormakabaCard = 'dormakabaCard',
  StandardCard = 'standardCard',
  Card = 'card',
}

export function getDefaultValues(isSiteDormakabaIntegrationEnabled: boolean) {
  return {
    [FormFieldNames.CardType]: isSiteDormakabaIntegrationEnabled
      ? FormFieldNames.DormakabaCard
      : FormFieldNames.StandardCard,
    [FormFieldNames.Card]: '',
  };
}

export function assignRfidCardValidationSchema(
  companyId: number,
  siteId: number,
  formatMessage: (message: MessageDescriptor) => string,
  assignedRef: React.RefObject<string | undefined>
) {
  return yup.object().shape({
    [FormFieldNames.CardType]: yup.string(),
    [FormFieldNames.Card]: yup.string().when([FormFieldNames.CardType], ([cardType], schema) => {
      const isDormakabaType = cardType === FormFieldNames.DormakabaCard;
      return isDormakabaType
        ? schema
            .min(6, formatMessage(messages.userRfidModalErrorsDormakabaWrongLength))
            .max(20, formatMessage(messages.userRfidModalErrorsDormakabaWrongLength))
            .matches(/^[0-9A-Fa-f]+$/, {
              excludeEmptyString: true,
              message: formatMessage(messages.assignRfidCardErrorWrongFormat),
            })
            .test({
              message: formatMessage(messages.assignRfidCardErrorCardAssigned),
              name: 'isAssigned',
              test: async (card) => {
                try {
                  if (!card || card.length === 0) {
                    return true;
                  }
                  const response = await getRfidCardOwner(companyId, siteId, removeLeadingZeros(card.toUpperCase()));
                  if (response.status === 200) {
                    if (!response.data?.userId) {
                      return true;
                    }
                    // eslint-disable-next-line no-param-reassign
                    assignedRef.current = response.data.userId;
                  } else {
                    // eslint-disable-next-line no-param-reassign
                    assignedRef.current = '';
                  }
                  return response.status === 404;
                } catch (error) {
                  return true;
                }
              },
            })
        : schema
            .min(6, formatMessage(messages.assignRfidCardErrorWrongLength))
            .max(32, formatMessage(messages.assignRfidCardErrorWrongLength))
            .matches(/^(?:[0-9A-Fa-f]+|[0-9A-Fa-f]{2}(?::[0-9A-Fa-f]{2})+)$/, {
              excludeEmptyString: true,
              message: formatMessage(messages.assignRfidCardErrorWrongFormat),
            })
            .test({
              message: formatMessage(messages.assignRfidCardErrorCardAssigned),
              name: 'isAssigned',
              test: async (card) => {
                try {
                  if (!card || card.length === 0) {
                    return true;
                  }
                  const response = await getRfidCardOwner(companyId, siteId, card.toUpperCase());
                  if (response.status === 200) {
                    if (!response.data?.userId) {
                      return true;
                    }
                    // eslint-disable-next-line no-param-reassign
                    assignedRef.current = response.data.userId;
                  } else {
                    // eslint-disable-next-line no-param-reassign
                    assignedRef.current = '';
                  }
                  return response.status === 404;
                } catch (error) {
                  return true;
                }
              },
            });
    }),
  });
}
